import {SelectionListGroupingModel} from '@/components/controls/selectionList/interfaces';

// Список группировок программных модулей
export const pmoduleGroupings: SelectionListGroupingModel[] = [
  {name: 'По узлу', keyFieldName: 'nodeId', aliasFieldName: 'nodeDescription'},
];
